module.exports = __webpack_public_path__ + "img/momo_correct.716d77db.png";